import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    highlight: {
        backgroundColor: '#efe83d'
    }
}));

export {useStyles}